import { render } from "./politique-de-confidentialite.vue?vue&type=template&id=dc457178"
import script from "./politique-de-confidentialite.vue?vue&type=script&lang=js"
export * from "./politique-de-confidentialite.vue?vue&type=script&lang=js"

import "./politique-de-confidentialite.vue?vue&type=style&index=0&id=dc457178&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__